var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var SearchSvg = /* @__PURE__ */ __name(function SearchSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M13.858 25.373c-6.478 0-11.729-5.251-11.729-11.729s5.251-11.729 11.729-11.729c6.478 0 11.729 5.251 11.729 11.729v0c-0.008 6.475-5.254 11.721-11.728 11.729h-0.001zM13.858 4.138c-5.25 0-9.507 4.256-9.507 9.507s4.256 9.507 9.507 9.507c5.25 0 9.507-4.256 9.507-9.507v0c-0.005-5.248-4.258-9.502-9.506-9.507h-0.001z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M20.456 22.52l1.545-1.597 8.417 8.143-1.545 1.597-8.417-8.143z"
  }));
}, "SearchSvg");
var SearchIcon = /* @__PURE__ */ __name(function SearchIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: SearchSvg
  }, props));
}, "SearchIcon");
export {
  SearchIcon
};
